import { Checkbox, Form, InputField } from "@/components/Form";
import * as z from "zod";
import { useUpdateProfileSettingMutation } from "../../api/account";
import { ProfileModel } from "../../types";
import { Button } from "@/components/Elements";
import { ROLES } from "@/libs/authorization";

const schema = z.object({
  maxAdvertCount: z.coerce.number(),
  savePostAsDraft: z.boolean().optional(),
});

type SettingModel = z.infer<typeof schema>;

export const UserSetting = ({ userDetail }: { userDetail: ProfileModel }) => {
  const [updateProfileSetting] = useUpdateProfileSettingMutation();
  const { userId, maxAdvertCount, savePostAsDraft, role } = userDetail;

  const handleUpdate = async (payload: SettingModel) => {
    updateProfileSetting({ ...payload, userId });
  };

  return (
    <Form<SettingModel, typeof schema>
      onSubmit={async (values) => {
        handleUpdate(values);
      }}
      schema={schema}
      options={{ defaultValues: { maxAdvertCount, savePostAsDraft } }}
    >
      {({ register, handleSubmit }) => (
        <div className="flex-1">
          <div className="flex flex-1 justify-between items-center">
            {ROLES.MERCHANT == role && (
              <div className="w-[45%]">
                <InputField
                  label="Merchant max advert"
                  placeholder="Merchant max advert"
                  registration={register("maxAdvertCount")}
                />
              </div>
            )}
            <div className="w-[45%]">
              <Checkbox
                label="Save post as draft"
                registration={register("savePostAsDraft")}
              />
            </div>
          </div>
          <Button onClick={handleSubmit(handleUpdate)}>Update</Button>
        </div>
      )}
    </Form>
  );
};
